module.exports = __webpack_public_path__ + "static/media/triv5.04710a49.gif";